export default __webpack_public_path__ + "resources/icons/d330-f6a7.png";